import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { rValue } from '../../models/.catalog';
import pOtpAl from '../../models/pOtpAl';
import rOtp from '../../models/rOtp';

export default class OtpAlApi extends ApiBase<pOtpAl, rValue<rOtp>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OtpAl',
      }),
      options
    );
    this._ServiceUrl = '/services/OyakExternal.asmx';
  }
}
